// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crear-contrato-form,
.crear-contrato-form *,
.crear-contrato-form *::before,
.crear-contrato-form *::after {
  box-sizing: border-box;
}

.crear-contrato-form {
  width: 100%;
  color: #2f4f70;
}

.crear-contrato-field {
  margin-bottom: 16px;
}

.crear-contrato-field label {
  display: block;
  margin-bottom: 8px;
  color: #3d5b7b;
  font-size: 14px;
  line-height: 1.25;
}

.crear-contrato-control {
  display: block;
  width: 100%;
  min-height: 41px;
  padding: 9px 12px;
  border: 1px solid #c9cdd2;
  border-radius: 4px;
  background-color: #fff;
  color: #1f1f1f;
  font: inherit;
  line-height: 1.25;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.crear-contrato-control:focus {
  border-color: #006699;
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 102, 153, 0.12);
}

.crear-contrato-form select.crear-contrato-control {
  padding-right: 34px;
}

.crear-contrato-actions {
  display: flex;
  justify-content: center;
  margin-top: 4px;
}

.crear-contrato-submit {
  position: relative;
  min-width: 96px;
  padding: 10px 20px;
  border: 0;
  border-radius: 4px;
  background-color: #006699;
  color: #fff;
  font-size: 16px;
  line-height: 1.25;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.crear-contrato-submit:not(:disabled):hover {
  background-color: #00547e;
  transform: translateY(-1px);
}

.crear-contrato-submit:disabled {
  color: #f5f5f5;
}

@media (max-width: 420px) {
  .crear-contrato-form {
    padding: 0 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/crearContrato3.css"],"names":[],"mappings":"AAAA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".crear-contrato-form,\n.crear-contrato-form *,\n.crear-contrato-form *::before,\n.crear-contrato-form *::after {\n  box-sizing: border-box;\n}\n\n.crear-contrato-form {\n  width: 100%;\n  color: #2f4f70;\n}\n\n.crear-contrato-field {\n  margin-bottom: 16px;\n}\n\n.crear-contrato-field label {\n  display: block;\n  margin-bottom: 8px;\n  color: #3d5b7b;\n  font-size: 14px;\n  line-height: 1.25;\n}\n\n.crear-contrato-control {\n  display: block;\n  width: 100%;\n  min-height: 41px;\n  padding: 9px 12px;\n  border: 1px solid #c9cdd2;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #1f1f1f;\n  font: inherit;\n  line-height: 1.25;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.crear-contrato-control:focus {\n  border-color: #006699;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(0, 102, 153, 0.12);\n}\n\n.crear-contrato-form select.crear-contrato-control {\n  padding-right: 34px;\n}\n\n.crear-contrato-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 4px;\n}\n\n.crear-contrato-submit {\n  position: relative;\n  min-width: 96px;\n  padding: 10px 20px;\n  border: 0;\n  border-radius: 4px;\n  background-color: #006699;\n  color: #fff;\n  font-size: 16px;\n  line-height: 1.25;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n.crear-contrato-submit:not(:disabled):hover {\n  background-color: #00547e;\n  transform: translateY(-1px);\n}\n\n.crear-contrato-submit:disabled {\n  color: #f5f5f5;\n}\n\n@media (max-width: 420px) {\n  .crear-contrato-form {\n    padding: 0 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
